import ProductPricesModule from './index.vue';

// eslint-disable-next-line import/prefer-default-export
export const productPricesRoutes = [
  {
    path: '/products',
    component: ProductPricesModule,
    children: [
      {
        path: 'productprices/',
        name: 'ManageProductPrices',
        component: () => import(/* webpackChunkName: "manage-products-prices" */ './pages/manage-product-prices.vue'),
        meta: {
          /** Access to this route is managed on the server no need to specify in the meta */
        },
      },
      {
        path: 'addPermitprice/:id',
        name: 'AddPermitPrice',
        component: () => import(/* webpackChunkName: "add-permit-price" */ './pages/add-permit-price.vue'),
        meta: {
          /** Access to this route is managed on the server no need to specify in the meta */
        },
      },
      {
        path: 'searchrequestprice/:id',
        name: 'AddSearchRequestPrice',
        component: () => import(/* webpackChunkName: "add-searchrequest-price" */ './pages/add-searchrequest-price.vue'),
        meta: {
          /** Access to this route is managed on the server no need to specify in the meta */
        },
      },
      {
        path: 'addmiscellaneousprice/:id',
        name: 'AddMiscellaneousPrice',
        component: () => import(/* webpackChunkName: "add-miscellaneous-price" */ './pages/add-miscellaneous-price.vue'),
        meta: {
          /** Access to this route is managed on the server no need to specify in the meta */
        },
      },
    ],
  },
];
